import { render, staticRenderFns } from "./IcoGame.vue?vue&type=template&id=93ec369c&"
import script from "./IcoGame.vue?vue&type=script&lang=js&"
export * from "./IcoGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports